import React from 'react';

interface AppCardProps {
  id: string;
  name: string;
  icon: string;
  status?: 'TRY' | 'NEW' | 'DISABLED' | null;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

const AppCard: React.FC<AppCardProps> = ({
  id,
  name,
  icon,
  status,
  onClick,
  className = '',
  disabled = false
}) => {
  const getStatusColor = (status: string | null | undefined) => {
    switch (status) {
      case 'TRY':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'NEW':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'DISABLED':
        return 'bg-gray-100 text-gray-500 border-gray-200';
      default:
        return '';
    }
  };

  const getStatusText = (status: string | null | undefined) => {
    switch (status) {
      case 'TRY':
        return 'Try';
      case 'NEW':
        return 'New';
      case 'DISABLED':
        return 'Coming Soon';
      default:
        return '';
    }
  };

  return (
    <div
      className={`bg-white rounded-lg border border-gray-200 p-3 sm:p-4 transition-shadow min-h-44 touch-manipulation ${
        disabled
          ? 'opacity-50 cursor-not-allowed'
          : 'hover:shadow-md cursor-pointer active:scale-95 active:shadow-lg'
      } ${className}`}
      onClick={disabled ? undefined : onClick}
    >
      <div className="flex items-start justify-between mb-2 sm:mb-3">
        <div className={`text-2xl sm:text-3xl ${disabled ? 'opacity-50' : ''}`}>{icon}</div>
        {status && (
          <span className={`px-2 py-1 text-xs font-medium rounded-full border ${getStatusColor(status)}`}>
            {getStatusText(status)}
          </span>
        )}
      </div>

      <h3 className={`text-base sm:text-lg font-semibold ${disabled ? 'text-gray-500' : 'text-gray-900'}`}>{name}</h3>
    </div>
  );
};

export default AppCard;
